export default __webpack_public_path__ + "static/TX1-67298b0de0bb66710c5e9027aa41d000.svg";